import { render } from "./Index.vue?vue&type=template&id=da68347a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=da68347a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da68347a"

export default script